/* Keep the source-workbook symbols in sync with Wonder's variant picker. */
(() => {
  if (customElements.get('ama-product-symbols')) return;
  customElements.define('ama-product-symbols', class extends HTMLElement {
    connectedCallback() {
      this.start = () => {
        if (!this.isConnected || this.unsubscribe) return;
        const source = this.querySelector('[data-symbol-map]');
        try { this.variantMap = JSON.parse(source.textContent); } catch (_) { return; }
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant || !Object.prototype.hasOwnProperty.call(this.variantMap, String(variant.id))) return;
          const selected = this.variantMap[String(variant.id)];
          this.querySelectorAll('[data-symbol-set]').forEach((panel) => {
            panel.hidden = panel.dataset.symbolSet !== selected;
          });
          this.querySelector('[data-symbol-fallback]').hidden = Boolean(selected);
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
      else this.start();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = null;
    }
  });
})();
